/* tslint:disable */
/* eslint-disable */
/**
 * Bookings API
 * Bookings API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateReservationRequestGatewayInfoOrder
 */
export interface CreateReservationRequestGatewayInfoOrder {
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequestGatewayInfoOrder
     */
    orderData: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequestGatewayInfoOrder
     */
    pspReference: string;
}

/**
 * Check if a given object implements the CreateReservationRequestGatewayInfoOrder interface.
 */
export function instanceOfCreateReservationRequestGatewayInfoOrder(value: object): value is CreateReservationRequestGatewayInfoOrder {
    if (!('orderData' in value) || value['orderData'] === undefined) return false;
    if (!('pspReference' in value) || value['pspReference'] === undefined) return false;
    return true;
}

export function CreateReservationRequestGatewayInfoOrderFromJSON(json: any): CreateReservationRequestGatewayInfoOrder {
    return CreateReservationRequestGatewayInfoOrderFromJSONTyped(json, false);
}

export function CreateReservationRequestGatewayInfoOrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReservationRequestGatewayInfoOrder {
    if (json == null) {
        return json;
    }
    return {
        
        'orderData': json['orderData'],
        'pspReference': json['pspReference'],
    };
}

export function CreateReservationRequestGatewayInfoOrderToJSON(json: any): CreateReservationRequestGatewayInfoOrder {
    return CreateReservationRequestGatewayInfoOrderToJSONTyped(json, false);
}

export function CreateReservationRequestGatewayInfoOrderToJSONTyped(value?: CreateReservationRequestGatewayInfoOrder | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderData': value['orderData'],
        'pspReference': value['pspReference'],
    };
}

